/* Dabi Deri — akan şerit. Kampanya merkezi öğelerini ekler, süreyi ölçer,
   içeriği iki kez kopyalayıp sonsuz akıtır, kargo eşiğini canlı günceller.
   Çarpı: şerit rulo gibi sarılıp yüzen simgeye uçar; simgeden geri açılır. */
(() => {
  const SPEED = { slow: 30, normal: 45, fast: 75 }; // eski seçim değerleri için yedek (px / sn)

  const formatMoney = (cents, fmt) => {
    const n = (Number(cents) || 0) / 100;
    const parts = (dec, thou, digits) => {
      const fixed = n.toFixed(digits);
      let [int, frac] = fixed.split('.');
      int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return frac !== undefined ? `${int}${dec}${frac}` : int;
    };
    const m = (fmt || '').match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    let out;
    switch (key) {
      case 'amount_no_decimals': out = parts('', ',', 0); break;
      case 'amount_with_comma_separator': out = parts(',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = parts('', '.', 0); break;
      case 'amount_with_apostrophe_separator': out = parts('.', "'", 2); break;
      case 'amount_no_decimals_with_space_separator': out = parts('', ' ', 0); break;
      case 'amount_with_space_separator': out = parts(',', ' ', 2); break;
      case 'amount_with_period_and_space_separator': out = parts('.', ' ', 2); break;
      default: out = parts('.', ',', 2);
    }
    return fmt ? fmt.replace(/\{\{\s*\w+\s*\}\}/, out) : out;
  };

  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    if (root.dataset.hideB2b === 'true' && root.dataset.isB2b === 'true') return;

    const list = root.querySelector('[data-ticker-list]');
    const sepTpl = root.querySelector('[data-ticker-sep]');
    const campTpl = root.querySelector('[data-ticker-campaign]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const addCampaigns = () => {
      if (root.dataset.campaigns !== 'true' || !campTpl) return;
      const now = Date.now();
      (window.DabiCampaigns || []).forEach((c) => {
        if (list.querySelector(`[data-campaign-id="${c.id}"]`)) return;
        if (c.ends) {
          const t = Date.parse(c.ends);
          if (!Number.isNaN(t) && t + 86399000 < now) return;
        }
        const li = campTpl.content.firstElementChild.cloneNode(true);
        li.dataset.campaignId = c.id;
        const prefix = root.dataset.campaignLabel ? `${root.dataset.campaignLabel} ` : '';
        li.querySelector('.dabi-ticker__text').textContent = `${prefix}${c.title || ''}${c.short ? ` — ${c.short}` : ''}`;
        li.querySelector('button').addEventListener('click', () => {
          document.dispatchEvent(new CustomEvent('dabi:campaigns:open', { detail: { id: c.id } }));
        });
        list.appendChild(li);
      });
    };

    const build = () => {
      // önceki klonları ve ayraçları temizle
      list.querySelectorAll('[data-ticker-clone], .dabi-ticker__sep-wrap').forEach((n) => n.remove());
      const items = Array.from(list.children).filter((li) => li.classList.contains('dabi-ticker__item'));
      if (items.length === 0) {
        root.hidden = true;
        document.querySelector(`[data-ticker-dock][data-for="${root.id}"]`)?.setAttribute('hidden', '');
        return;
      }
      // ayraçları ekle
      items.forEach((li) => {
        const w = document.createElement('li');
        w.className = 'dabi-ticker__sep-wrap';
        w.setAttribute('aria-hidden', 'true');
        if (sepTpl) w.appendChild(sepTpl.content.cloneNode(true));
        li.after(w);
      });
      root.hidden = false;
      // toplanmışken (görünmezken) ölçüm yapılamaz; açılınca yeniden kurulur
      if (reduced || root.classList.contains('is-collapsed')) return;
      // içerik görünür alanı dolduracak kadar çoğaltılır, sonra tamamı bir kez daha kopyalanır (%50 kayma döngüsü)
      const trackW = root.querySelector('[data-ticker-track]').getBoundingClientRect().width || window.innerWidth;
      const originals = Array.from(list.children);
      let width = list.getBoundingClientRect().width;
      let guard = 0;
      while (width < trackW && guard < 10) {
        originals.forEach((n) => { const c = n.cloneNode(true); c.setAttribute('data-ticker-clone', ''); c.setAttribute('aria-hidden', 'true'); list.appendChild(c); });
        width = list.getBoundingClientRect().width;
        guard += 1;
      }
      const half = Array.from(list.children);
      half.forEach((n) => { const c = n.cloneNode(true); c.setAttribute('data-ticker-clone', ''); c.setAttribute('aria-hidden', 'true'); list.appendChild(c); });
      // klonlardaki düğmeler de çalışsın
      list.querySelectorAll('[data-ticker-clone] button').forEach((b) => {
        const id = b.closest('[data-campaign-id]')?.dataset.campaignId;
        if (id) b.addEventListener('click', () => document.dispatchEvent(new CustomEvent('dabi:campaigns:open', { detail: { id } })));
      });
      const pxPerSec = Number(root.dataset.speed) || SPEED[root.dataset.speed] || SPEED.normal;
      const dur = Math.max(12, Math.round(width / pxPerSec));
      list.style.setProperty('--dabi-ticker-dur', `${dur}s`);
    };

    const shipping = root.querySelector('[data-ticker-shipping]');
    const updateShipping = (total) => {
      if (!shipping) return;
      const thr = Number(shipping.dataset.threshold) || 0;
      const left = thr - (Number(total) || 0);
      const text = left > 0
        ? shipping.dataset.textLeft.replace('{amount}', formatMoney(left, root.dataset.moneyFormat))
        : shipping.dataset.textDone;
      root.querySelectorAll('[data-ticker-shipping-text]').forEach((el) => { el.textContent = text; });
    };

    if (root.classList.contains('dabi-ticker--sticky')) {
      const hdr = document.querySelector('.dabi-header-wrap');
      if (hdr) root.style.top = `${Math.round(hdr.getBoundingClientRect().height)}px`;
    }
    // geri sayım ve kupon (klonlar dahil, event delegation)
    const tick = () => {
      root.querySelectorAll('[data-ticker-countdown]').forEach((li) => {
        const end = Date.parse(li.dataset.tickerCountdown);
        const left = end - Date.now();
        const el = li.querySelector('[data-countdown-text]');
        if (!el || Number.isNaN(end)) return;
        if (left <= 0) { li.hidden = true; return; }
        const d = Math.floor(left / 86400000); const h = Math.floor((left % 86400000) / 3600000); const m = Math.floor((left % 3600000) / 60000);
        const t = `${d > 0 ? `${d}${li.dataset.unitD} ` : ''}${h}${li.dataset.unitH} ${String(m).padStart(2, '0')}${li.dataset.unitM}`;
        el.textContent = li.dataset.text.replace('{time}', t);
      });
    };
    tick();
    window.setInterval(tick, 30000);
    root.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-ticker-copy]');
      if (!b) return;
      try { await navigator.clipboard.writeText(b.dataset.tickerCopy); } catch (err) { /* pano yok */ }
      const li = b.closest('.dabi-ticker__item');
      const em = b.querySelector('.dabi-ticker__code');
      li.classList.add('is-copied');
      const old = em.textContent; em.textContent = b.dataset.copied || old;
      window.setTimeout(() => { li.classList.remove('is-copied'); em.textContent = old; }, 1600);
    });
    addCampaigns();
    build();
    document.addEventListener('dabi:campaigns:ready', () => { addCampaigns(); build(); });
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (e) => {
        const total = e?.cartData?.total_price;
        if (typeof total === 'number') updateShipping(total);
        else fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json()).then((c) => updateShipping(c.total_price)).catch(() => {});
      });
    }

    // Başlığın altındaki sabit öğeler (kampanya madalyonu) şeridin görünen yüksekliği kadar aşağı kayar.
    const writeHeight = () => {
      const hb = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dabi-header-bottom')) || 0;
      const inHeader = !!root.closest('.shopify-section-group-header-group');
      const b = (root.hidden || !inHeader) ? 0 : Math.max(0, Math.round(root.getBoundingClientRect().bottom - hb));
      document.documentElement.style.setProperty('--dabi-ticker-height', `${b}px`);
    };
    writeHeight();
    let sr;
    window.addEventListener('scroll', () => { if (sr) return; sr = window.requestAnimationFrame(() => { sr = 0; writeHeight(); }); }, { passive: true });
    window.addEventListener('resize', writeHeight);

    /* ---------- Toplama: şerit rulo gibi sarılır, yüzen simgeye uçar; simgeden geri açılır ---------- */
    const STORE = 'dabi-ticker-rolled';
    const closeBtn = root.querySelector('[data-ticker-close]');
    const dock = (() => {
      const d = document.querySelector(`[data-ticker-dock][data-for="${root.id}"]`);
      if (!d) return null;
      document.querySelectorAll('body > [data-ticker-dock]').forEach((o) => { if (o !== d) o.remove(); });
      if (d.parentElement !== document.body) document.body.appendChild(d);
      return d;
    })();
    const rememberMs = (Number(root.dataset.remember) || 0) * 3600000;
    const savedRolled = () => {
      if (!rememberMs) return false;
      try { return Number(localStorage.getItem(STORE) || 0) > Date.now(); } catch (err) { return false; }
    };
    const saveRolled = (on) => {
      try {
        if (on && rememberMs) localStorage.setItem(STORE, String(Date.now() + rememberMs));
        else localStorage.removeItem(STORE);
      } catch (err) { /* depolama yok */ }
    };
    const look = (Array.from(root.classList).find((c) => /^dabi-ticker--(linen|bold|soft|custom)$/.test(c)) || 'dabi-ticker--linen').replace('dabi-ticker--', '');
    const EASE = 'cubic-bezier(.65, 0, .35, 1)';
    // Animasyon bitişini bekle; sekme arka plandaysa zaman çizelgesi durabilir, süre + pay sonunda yine de devam et
    const done = (a) => {
      if (!a) return Promise.resolve();
      const ms = Number(a.effect?.getComputedTiming?.().endTime) || 800;
      return Promise.race([a.finished.catch(() => {}), new Promise((r) => { window.setTimeout(r, ms + 250); })]);
    };
    let busy = false;
    let queued = false; // simge uçuş bitmeden tıklanırsa iniş sonrası açılır

    // Şeridin yüksekliği değişti: filtre rayı, yüzen öğeler vb. yeniden ölçsün
    const relayout = () => window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    const setRolled = (on) => {
      root.classList.toggle('is-collapsed', on);
      if (dock) dock.hidden = !on || root.hidden;
      closeBtn?.setAttribute('aria-expanded', String(!on));
      dock?.setAttribute('aria-expanded', String(!on));
      writeHeight();
      relayout();
    };

    const makeRoll = () => {
      const r = document.createElement('span'); // boş div'i tema gizler (div:empty)
      r.className = `dabi-ticker-roll dabi-ticker-roll--${look}`;
      r.setAttribute('aria-hidden', 'true');
      if (look === 'custom') ['--dabi-tk-bg', '--dabi-tk-fg', '--dabi-tk-ac'].forEach((v) => r.style.setProperty(v, root.style.getPropertyValue(v)));
      document.body.appendChild(r);
      return r;
    };
    // Rulonun ölçüleri: boyu şerit kadar, kalınlığı sarıldıkça artar
    const geo = (rect) => {
      const h = rect.height;
      const rh = Math.max(28, h * 0.92);
      return { h, rh, top: rect.top + (h - rh) / 2, d0: Math.max(10, h * 0.3), d1: Math.max(18, h * 0.62) };
    };
    const iconCenter = () => {
      const r = (dock.querySelector('.dabi-ticker-dock__icon') || dock).getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2, s: r.height };
    };

    const collapse = async () => {
      if (busy || root.classList.contains('is-collapsed')) return;
      const fromKeyboard = document.activeElement === closeBtn;
      const rect = root.getBoundingClientRect();
      const visible = rect.bottom > 0 && rect.top < window.innerHeight;
      saveRolled(true);
      if (reduced || !visible || !dock || !root.animate) {
        setRolled(true);
        if (fromKeyboard) dock?.focus();
        return;
      }
      busy = true;
      const g = geo(rect);
      const W = rect.width;
      const T = Math.min(1100, Math.max(650, W * 0.55));
      const roll = makeRoll();
      Object.assign(roll.style, { top: `${g.top}px`, left: `${rect.left}px`, width: `${g.d0}px`, height: `${g.rh}px` });
      root.classList.add('is-rolling');

      // 1) soldan sağa sarılır: rulo kalınlaşarak ilerler, geride şerit kalmaz
      const wind = roll.animate([
        { left: `${rect.left}px`, width: `${g.d0}px`, backgroundPosition: '0 0, 0 0' },
        { left: `${rect.right - g.d1}px`, width: `${g.d1}px`, backgroundPosition: `${Math.round(-W * 0.6)}px 0, 0 0` },
      ], { duration: T, easing: EASE, fill: 'forwards' });
      const clip = root.animate([
        { clipPath: `inset(0 0 0 ${g.d0 / 2}px)` },
        { clipPath: `inset(0 0 0 ${W - g.d1 / 2}px)` },
      ], { duration: T, easing: EASE, fill: 'forwards' });
      await done(wind);

      // 2) boşluk kapanır, rulo hafifçe havalanır
      const shrink = root.animate([{ height: `${g.h}px`, minHeight: '0px' }, { height: '0px', minHeight: '0px' }], { duration: 320, easing: EASE, fill: 'forwards' });
      roll.animate([{ transform: 'none' }, { transform: 'translateY(-6px) rotate(-8deg)' }], { duration: 320, easing: 'ease-out', fill: 'forwards' });
      await done(shrink);
      setRolled(true);
      clip.cancel();
      shrink.cancel();
      root.classList.remove('is-rolling');

      // 3) rulo kavis çizerek köşedeki simgeye uçar ve simgeye dönüşür
      dock.style.opacity = '0';
      const rr = roll.getBoundingClientRect();
      const c = iconCenter();
      const dx = c.x - (rr.left + rr.width / 2);
      const dy = c.y - (rr.top + rr.height / 2);
      const sc = Math.min(1, (c.s * 0.8) / g.rh);
      const lift = Math.min(160, Math.abs(dy) * 0.3 + 60);
      const fly = roll.animate([
        { transform: 'translateY(-6px) rotate(-8deg) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - lift}px) rotate(-60deg) scale(${(1 + sc) / 2})`, opacity: 1, offset: 0.5 },
        { transform: `translate(${dx}px, ${dy}px) rotate(-90deg) scale(${sc})`, opacity: 0.15 },
      ], { duration: 820, easing: 'cubic-bezier(.45, 0, .25, 1)', fill: 'forwards' });
      await done(fly);
      roll.remove();
      dock.style.opacity = '';
      dock.animate([
        { transform: 'scale(.4)', opacity: 0 },
        { transform: 'scale(1.12)', opacity: 1, offset: 0.6 },
        { transform: 'scale(1)', opacity: 1 },
      ], { duration: 440, easing: 'cubic-bezier(.34, 1.4, .5, 1)' });
      dock.classList.remove('is-landed');
      void dock.offsetWidth;
      dock.classList.add('is-landed', 'is-hinting');
      window.setTimeout(() => dock.classList.remove('is-hinting'), 2800);
      busy = false;
      if (fromKeyboard) dock.focus();
      if (queued) { queued = false; expand(); }
    };

    const expand = async () => {
      if (busy) { queued = true; return; }
      if (!root.classList.contains('is-collapsed')) return;
      const fromKeyboard = document.activeElement === dock;
      saveRolled(false);
      const c = iconCenter();
      root.classList.remove('is-collapsed');
      build();
      closeBtn?.setAttribute('aria-expanded', 'true');
      dock.setAttribute('aria-expanded', 'true');
      if (reduced || !root.animate) {
        dock.hidden = true;
        writeHeight();
        relayout();
        if (fromKeyboard) closeBtn?.focus();
        return;
      }
      busy = true;
      root.classList.add('is-rolling');
      root.style.clipPath = 'inset(0 0 0 100%)';
      let rect = root.getBoundingClientRect();
      const hb = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dabi-header-bottom')) || 0;
      let grow = null;
      if (rect.top < hb || rect.bottom > window.innerHeight) {
        // şerit görünürde değilse önce oraya yumuşakça kaydır
        window.scrollTo({ top: Math.max(0, window.scrollY + rect.top - hb - 16), behavior: 'smooth' });
        await new Promise((r) => { window.setTimeout(r, 600); });
        rect = root.getBoundingClientRect();
      } else {
        grow = root.animate([{ height: '0px', minHeight: '0px' }, { height: `${rect.height}px`, minHeight: '0px' }], { duration: 380, easing: EASE });
      }
      const g = geo(rect);
      const W = rect.width;
      const T = Math.min(1100, Math.max(650, W * 0.55));
      const roll = makeRoll();
      Object.assign(roll.style, { top: `${g.top}px`, left: `${rect.right - g.d1}px`, width: `${g.d1}px`, height: `${g.rh}px` });
      const dx = c.x - (rect.right - g.d1 / 2);
      const dy = c.y - (g.top + g.rh / 2);
      const sc = Math.min(1, (c.s * 0.8) / g.rh);
      const lift = Math.min(160, Math.abs(dy) * 0.3 + 60);

      // 1) simge küçülüp kaybolur, rulo havalanıp şeridin sağ ucuna konar
      const away = dock.animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(.4)', opacity: 0 }], { duration: 260, easing: 'ease-in', fill: 'forwards' });
      done(away).then(() => { dock.hidden = true; away.cancel(); });
      const fly = roll.animate([
        { transform: `translate(${dx}px, ${dy}px) rotate(-90deg) scale(${sc})`, opacity: 0.15 },
        { transform: `translate(${dx * 0.55}px, ${dy * 0.55 - lift}px) rotate(-30deg) scale(${(1 + sc) / 2})`, opacity: 1, offset: 0.5 },
        { transform: 'none', opacity: 1 },
      ], { duration: 780, easing: 'cubic-bezier(.45, 0, .25, 1)' });
      await done(fly);
      await done(grow);
      grow?.cancel();

      // 2) sağdan sola açılır: rulo inceldikçe şerit geri gelir
      const unwind = roll.animate([
        { left: `${rect.right - g.d1}px`, width: `${g.d1}px`, backgroundPosition: `${Math.round(-W * 0.6)}px 0, 0 0` },
        { left: `${rect.left}px`, width: `${g.d0}px`, backgroundPosition: '0 0, 0 0' },
      ], { duration: T, easing: EASE, fill: 'forwards' });
      const reveal = root.animate([
        { clipPath: `inset(0 0 0 ${W - g.d1 / 2}px)` },
        { clipPath: `inset(0 0 0 ${g.d0 / 2}px)` },
      ], { duration: T, easing: EASE, fill: 'forwards' });
      root.style.clipPath = '';
      await done(unwind);
      reveal.cancel();
      root.classList.remove('is-rolling');
      done(roll.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, fill: 'forwards' })).then(() => roll.remove());
      writeHeight();
      relayout();
      busy = false;
      if (fromKeyboard) closeBtn?.focus();
    };

    closeBtn?.addEventListener('click', collapse);
    dock?.addEventListener('click', expand);
    if (dock && savedRolled()) setRolled(true);
    document.addEventListener('shopify:section:unload', (e) => {
      if (e.detail?.sectionId === root.dataset.id) dock?.remove();
    });

    // dokunmatikte basılı tutunca duraklat
    root.addEventListener('pointerdown', () => root.classList.add('is-paused'));
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => root.addEventListener(ev, () => root.classList.remove('is-paused')));

    let rt;
    window.addEventListener('resize', () => { window.clearTimeout(rt); rt = window.setTimeout(build, 200); });
  };

  const boot = () => document.querySelectorAll('[data-dabi-ticker]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const r = e.target.querySelector('[data-dabi-ticker]'); if (r) { delete r.dataset.ready; init(r); } });
})();
